<div class="pre-loader" *ngIf="!doneLoading"></div>
<div class="site-container">
    <div class="login-wrap">
        <div class="login-content">
            <div class="inner" [ngSwitch]="pageMode">
                <img class="logo" src="images/PDX-logo.svg" alt="PDx" />
                <div id="login-form" *ngSwitchCase="'login'">
                    <form novalidate #loginForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
                        <div class="animated-input input-inline-icon mb-3">
                            <input type="email" focus-me name="username" class="form-control form-control-lg border-left-0" placeholder="Email" required [(ngModel)]="login.username" />
                            <span class="underline"></span>
                            <span class="input-icon"><i class="fal fa-envelope"></i></span>
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="animated-input input-inline-icon mb-4">
                            <input type="password" name="password" class="form-control form-control-lg" placeholder="Password" required [(ngModel)]="login.password" />
                            <span class="underline"></span>
                            <span class="input-icon"><i class="fal fa-lock"></i></span>
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="d-grid">
                            <button type="submit" class="btn btn-lg btn-primary btn-round mt-3 text-strong hvr-grow" (click)="doLogin()">Login <i class="far fa-arrow-right"></i></button>
                        </div>
                        <h5 class="mt-5 text-center text-normal"><a href="javascript:void(0)" (click)="switchMode('resetPassword')" id="forgot-password-link" class="text-body">Forgot
                                your password?</a></h5>
                    </form>
                </div>
                <div id="forgot-password-form" *ngSwitchCase="'resetPassword'">
                    <form novalidate #resetForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
                        <h4 class="text-strong mb-1">Password Reset</h4>
                        <p>Enter your account’s email address and we will email you a link to reset your password.</p>
                        <div class="animated-input input-inline-icon mb-4">
                            <span class="input-icon"><i class="fal fa-envelope"></i></span>
                            <input type="text" focus-me name="resetEmail" class="form-control form-control-lg border-left-0" placeholder="Email" required [(ngModel)]="login.username" />
                            <span class="underline"></span>
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="d-grid">
                            <button type="submit" class="btn btn-lg btn-primary btn-round text-strong" (click)="doReset()"><i class="far fa-paper-plane"></i> Send Reset Link</button>
                        </div>
                        <h5 class="mt-5 text-center text-normal"><a id="login-back-link" class="text-body" href="javascript:void(0)" (click)="switchMode('login')"><i class="far fa-arrow-left"></i> back to login</a></h5>
                    </form>
                </div>
            </div>
        </div>
        <div class="marbles-img">
            <img src="images/marbles.svg" alt="marbles" />
        </div>
    </div>
</div>